module.exports = __webpack_public_path__ + "static/successfully.a6b46134.svg";